import { memo } from 'react';

import { GiSoundWaves } from 'react-icons/gi';
import { FiHeadphones } from 'react-icons/fi';

import useWebinarLobby from '../hooks/useWebinarLobby';

import { OButton, OInput, OTooltip } from '@src/shared';

import { LoaderIcon } from '@src/assets/icons';
import AttendeeViewImg from '@src/assets/images/webinar/AttendeeView.png';

import styles from './attendeeLobby.module.scss';

const AttendeeLobby = () => {
  const {
    customTooltipStyle,
    errors,
    handleChangeUsername,
    handleJoinWebinar,
    inputValue,
    isJoinLoading,
    isPasswordRequired,
    isSubmitButtonDisabled,
    isWebinarStartedByHost,
    password,
  } = useWebinarLobby();

  return (
    <div className={styles.lobbyWrapper}>
      <div className={`${styles.bgBubble} ${styles.bgBubbleLg}`} />
      <div className={`${styles.bgBubble} ${styles.bgBubbleMd}`} />
      <div className={`${styles.bgBubble} ${styles.bgBubbleSm}`} />

      <div className={styles.card}>
        <div className={styles.illustrationWrapper}>
          <img src={AttendeeViewImg} alt="Listen mode" className={styles.illustration} />
        </div>

        <p className={styles.title}>v webinar meeting</p>
        <p className={styles.subtitle}>Join the webinar</p>

        <div className={styles.infoText}>
          <GiSoundWaves size={24} color="#05acfb" />
          <p>You’ll join in Listen Mode - Sit back, relax, and enjoy the session</p>
        </div>

        {isWebinarStartedByHost ? (
          <div className={styles.joinMeetingWrapper}>
            <>
              <OInput
                className={styles.input}
                placeholder="Nickname"
                value={inputValue}
                onChange={(e) => handleChangeUsername(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleJoinWebinar();
                  }
                }}
              />
              {errors.username && <p className={styles.invalid}>{errors.username}</p>}
            </>

            <OTooltip
              title={
                isSubmitButtonDisabled && isPasswordRequired && !password
                  ? 'Please enter your Nickname and Password first.'
                  : isSubmitButtonDisabled
                    ? 'Please enter your Nickname first.'
                    : isPasswordRequired && !password
                      ? 'Please enter your Password first.'
                      : ''
              }
              customStyles={customTooltipStyle}
              placement="top"
            >
              <>
                <OButton
                  variant="alternative"
                  size="full"
                  text="Join meeting"
                  loading={isJoinLoading}
                  isDisabled={isSubmitButtonDisabled || (isPasswordRequired && !password) || isJoinLoading}
                  onClick={handleJoinWebinar}
                />
              </>
            </OTooltip>
          </div>
        ) : (
          <div className={styles.waitingForHostWrapper}>
            <p>Waiting for host to start the meeting</p>
            <div className={styles.loaderWrapper}>
              <LoaderIcon width={29} height={29} />
            </div>
          </div>
        )}

        <div className={styles.footerNote}>
          <FiHeadphones size={20} color="#05ACFB" />
          <p>Audio-only participation No camera required</p>
        </div>
      </div>
    </div>
  );
};

export default memo(AttendeeLobby);
